import { createStyles, makeStyles } from '@material-ui/core/styles';
import { StandardDivProps } from '@sprinx/react-mui-components/StandardDiv';
import withThemeProps from '@sprinx/react-mui-components/withThemeProps';
import clsx from 'clsx';
import React from 'react';
import { CatalogueProduct } from '../../../api/products/catalogue';
import { useAddToCart } from '../../../api/shoppingCart';
import AddToCartButtonToQty from '../../../components/AddToCartButtonToQty';
import useTranslateWithFallback from '../../../hooks/useTranslateWithFallback';

export interface CataloguePageListContentItemRowAddToCartProps
  extends StandardDivProps<CataloguePageListContentItemRowAddToCartClassKey> {
  product: CatalogueProduct;
}

export type CataloguePageListContentItemRowAddToCartClassKey =
  | 'root'
  | 'qfWrapper'
  | 'cartInfo'
  | 'content'
  | 'withCartInfo';

const themeSettings = { name: 'CataloguePageListContentItemRowAddToCart' };

const useStyles = makeStyles(
  createStyles<CataloguePageListContentItemRowAddToCartClassKey, {}>({
    root: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'flex-end',
      position: 'relative',
    },
    withCartInfo: {
      flexDirection: 'column',
      alignItems: 'flex-end',
    },
    qfWrapper: {
      justifyContent: 'flex-end',
    },
    content: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'flex-end',
      width: '100%',
    },
    cartInfo: {
      backgroundColor: '#002969',
      color: 'white',
      padding: '4px 8px',
      borderRadius: 4,
      fontSize: 12,
      textAlign: 'center',
      marginTop: 8,
      marginBottom: 2,
    },
  }),
  themeSettings,
);

const CataloguePageListContentItemRowAddToCart = React.forwardRef<
  HTMLDivElement,
  CataloguePageListContentItemRowAddToCartProps
>(({ className, classes: pClasses, product }, ref) => {
  const classes = useStyles({ classes: pClasses });
  const t = useTranslateWithFallback();

  const {
    addToCart,
    quantity = 0,
    ...addToCartProps
  } = useAddToCart({
    forcePreventDecrement: true,
    product,
  });

  return (
    <div
      ref={ref}
      className={clsx(classes.root, className, {
        [classes.withCartInfo]: quantity > 0,
      })}
    >
      <AddToCartButtonToQty
        onAddToCart={addToCart}
        quantity={quantity}
        {...addToCartProps}
        product={product}
        QuantityFieldProps={{
          classes: {
            wrapper: classes.qfWrapper,
          },
        }}
      />

      {quantity > 0 && (
        <div className={classes.cartInfo}>
          <strong>
            {quantity} {t(quantity === 1 ? 'app/pcsInCartUnitSingular' : 'app/pcsInCartUnitPlural')}
          </strong>{' '}
          {t('app/pcsInCart')}
        </div>
      )}
    </div>
  );
});

CataloguePageListContentItemRowAddToCart.displayName = 'CataloguePageListContentItemRowAddToCart';

export default withThemeProps(themeSettings)(CataloguePageListContentItemRowAddToCart);
